import { deepOrange } from "@material-ui/core/colors";

export const useStyles = (theme) => ({
  root: {
    display: "flex",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  labelStyle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  inputLabel: {
    padding: "9px",
    marginRight: "5px",
    width: "45%",
  },

  addressFul: {
    padding: "9px",
    width: "75%",
  },

  headingS: {
    padding: "9px",
    alignItems: "center",
  },

  buttonS: {
    padding: "8px",
    marginLeft: "9px",
    marginBottom: "5px",
    color: "red",
    width: "25%",
    textAlignment: "center",
  },

  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    margin: theme.spacing(2),
    width: theme.spacing(7),
    height: theme.spacing(7),
    // marginBottom: "19px",
  },

  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "25ch",
  },

  tooltip: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  buttonStyle: {
    backgroundColor: "#004f70 !important",
    borderRadius: 20,
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#004f70 !important",
      color: "#000",
    },
  },
});
